import React, { Component } from "react";
import { graphql } from "react-apollo";
import { queryGetTemplateList } from "Apollo";
import Row from "./RowWithMutation";

export default graphql(queryGetTemplateList)(
  class List extends Component {
    render() {
      const getTemplateList = this.props.data.getTemplateList;
      const list = getTemplateList ? getTemplateList : [];
      const renders = list.map((row, index) => (
        <Row
          key={row.id}
          id={row.id}
          index={index + 1}
          title={row.content}
          arrOfTemplate={row.templateReply}
        />
      ));
      return renders;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/template-reply/ListWithQuery.js